import { GameCategory, LocalizedStringMap, TPaging } from "@/api";

import MethodBuilder from "../method-builder";

export class GameCategoryAPI {
  static getById = new MethodBuilder<{ id: number }, GameCategory>()
    .withName("GameCategory.getById")
    .build();

  static getAll = new MethodBuilder<
    {
      searchQuery?: string;
      orderBy?: ["id", "asc" | "desc"];
      gameCategoryRubricatorId: number;
    },
    { data: GameCategory[]; total: number }
  >()
    .withName("GameCategory.getAll")
    .build();

  static create = new MethodBuilder<
    {
      names: LocalizedStringMap;
      isActive: boolean;
      order: number;
      parentId: number | null;
      tag: "header" | "menu" | "bottom" | null;
      gameCategoryRubricatorId: number;
    },
    GameCategory
  >()
    .withName("GameCategory.create")
    .build();

  static update = new MethodBuilder<
    {
      id: number;
      isActive?: boolean;
      order?: number;
      tag?: "header" | "menu" | "bottom" | null;
      names?: LocalizedStringMap;
      domainIdsBlacklist?: number[];
      domainIdsWhitelist?: number[];
      gameCategoryRubricatorId?: number;
    },
    void
  >()
    .withName("GameCategory.update")
    .build();

  static delete = new MethodBuilder<{ id: number }, void>()
    .withName("GameCategory.delete")
    .build();

  static filter = new MethodBuilder<
    {
      searchQuery?: string;
      paging?: TPaging;
      gameCategoryRubricatorId?: number;
      gameId?: number;
      parentId?: number;
    },
    { data: GameCategory[]; total: number }
  >()
    .withName("GameCategory.filter")
    .build();

  static updateGames = new MethodBuilder<
    {
      categoryId: number;
      gameIds: number[];
    },
    void
  >()
    .withName("GameCategory.updateGames")
    .build();

  static upsertActions = new MethodBuilder<
    {
      categoryId: number;
      actions: {
        domainPriority?: number;
        domainId: number | null;
        type:
          | "main"
          | "game"
          | "document"
          | "contacts"
          | "category"
          | "sport_history"
          | "sport_from_shop"
          | "wallet"
          | "new_games"
          | "popular_games"
          | "promoted_games";
        data: string | null;
      }[];
    },
    void
  >()
    .withName("GameCategory.upsertActions")
    .build();

  static deleteActions = new MethodBuilder<
    {
      categoryId: number;
      actionsIds: number[];
    },
    void
  >()
    .withName("GameCategory.deleteActions")
    .build();
}
